var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"capacity-body"},[_c('img',{staticClass:"Study-list-img",attrs:{"src":require("@a/Study-list.png"),"alt":""},on:{"click":function($event){return _vm.toList()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }